import { render, staticRenderFns } from "./Addstudent.vue?vue&type=template&id=62f7b132&"
import script from "./Addstudent.vue?vue&type=script&lang=js&"
export * from "./Addstudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports